// src/pages/marketing/ScholingenPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/marketing/Navbar";
import Footer from "../../components/marketing/Footer";

const ScholingenPage = () => {
  return (
    <div className="min-h-screen bg-cream-100 text-charcoal-800 font-['Lexend_Deca'] text-base leading-relaxed">
      <Navbar />

      <main className="container mx-auto max-w-4xl py-20 px-5 mt-[70px]">
        <h1 className="font-['Lexend_Deca'] text-4xl text-gray-700 mb-12 text-center">
          Onze Scholingen
        </h1>

        <div className="flex flex-col gap-8 mb-20">
          {/* Course Card */}
          <Link
            to="/haalmeeruitverandertaal"
            className="flex flex-col md:flex-row items-stretch bg-white no-underline text-inherit border border-purple-800 border-opacity-15 transition-all duration-250 overflow-hidden hover:-translate-y-1 hover:border-purple-800 hover:border-opacity-30 hover:shadow-lg"
          >
            <img
              src="/verandertaal.png"
              alt="Online simulatietraining Motiverende Gespreksvoering"
              className="w-full md:w-60 h-45 md:h-auto object-cover"
            />
            <div className="p-6 md:p-8 flex-1 flex flex-col justify-center">
              <h2 className="font-['Lexend_Deca'] mt-0 text-purple-800 text-xl md:text-2xl mb-2">
                Haal meer uit verandertaal!
              </h2>
              <p className="my-1">
                In deze training oefen je met een aantal basistechnieken van
                motiverende gespreksvoering: vragen stellen en reflecties geven
                om verandertaal uit te lokken. Als jij al wel theoretische
                kennis hebt over motiverende gespreksvoering, maar toepassing in
                de praktijk nog lastig vindt, is deze training een perfecte
                start!
              </p>
              <p className="my-1">
                <strong>Duur:</strong> 5,5 uur
              </p>
              <p className="my-1">
                <strong>Accreditatie:</strong> is aangevraagd bij ADAP voor 5,5
                punten
              </p>
              <p className="my-1">
                <strong>Doelgroepen:</strong> diëtisten, ergotherapeuten,
                oefentherapeuten, logopedisten, huidtherapeuten,
                podotherapeuten, orthoptisten, optometristen en MBB'ers.
              </p>
              <p className="my-1">
                <strong>Thema's:</strong> verandertaal, open vragen stellen,
                reflecteren, basistechnieken
              </p>
              <p className="mt-3 text-purple-500 font-semibold">
                Bekijk details →
              </p>
            </div>
          </Link>

          {/* Future courses can be added here */}
          {/* Uncomment when les2 is available
          <Link
            to="/les2"
            className="flex flex-col md:flex-row items-stretch bg-white no-underline text-inherit border border-purple-800 border-opacity-15 transition-all duration-250 overflow-hidden hover:-translate-y-1 hover:border-purple-800 hover:border-opacity-30 hover:shadow-lg"
          >
            <img
              src="/training2.png"
              alt="MVG Gevorderd"
              className="w-full md:w-60 h-45 md:h-auto object-cover"
            />
            <div className="p-6 md:p-8 flex-1 flex flex-col justify-center">
              <h2 className="font-['Lexend_Deca'] mt-0 text-purple-800 text-xl md:text-2xl mb-2">
                Motiverende Gespreksvoering Gevorderd
              </h2>
              <p className="my-1">
                Deze vervolg training bouwt voort op de basisvaardigheden en verdiept je kennis van motiverende gespreksvoering.
              </p>
              <p className="my-1"><strong>Duur:</strong> 4 uur</p>
              <p className="my-1"><strong>Status:</strong> Binnenkort beschikbaar</p>
              <p className="mt-3 text-purple-500 font-semibold">
                Bekijk details →
              </p>
            </div>
          </Link>
          */}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ScholingenPage;
